import { render, staticRenderFns } from "./ProfileAdd.vue?vue&type=template&id=2f710d15&scoped=true"
import script from "./ProfileAdd.vue?vue&type=script&lang=js"
export * from "./ProfileAdd.vue?vue&type=script&lang=js"
import style0 from "./ProfileAdd.vue?vue&type=style&index=0&id=2f710d15&prod&scoped=true&lang=scss"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f710d15",
  null
  
)

export default component.exports